import style from "./Banner.module.css";
function Banner() {
  return (
    <div className={"position-relative  " + style.banner}>
      <div className={style.img}>
        <img src="./building/img-2024-02-29_11-36-56.jpg" alt="" />
      </div>

      {/* کد زیر پاک نشود-ممکن است دوباره استفاده شود */}
      {/* <div className={"position-absolute " + style.note}>
        <p>آواکس برای خدمات ارزشمندی که شایسته آنید</p>
        <p className="d-none d-lg-block">
          Avaex for the valuable service you deserve
        </p>
      </div> */}
    </div>
  );
}

export default Banner;
